import { submitContactUsForm, SubmitContactUsFormApiParameter } from "@carotek/Services/ContactUsFormServices";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";

type SubmitContactFormParameter = {
    emailRecipients: string;
} & HasOnSuccess &
    HasOnError;

type CustomHandlerType = ApiHandlerDiscreteParameter<SubmitContactFormParameter, SubmitContactUsFormApiParameter, any>;

const CustomPopulateApiParameter: CustomHandlerType = props => {
    const state = props.getState().components.contactUsForm;

    props.apiParameter = {
        firstname: state.fieldValues["firstName"],
        lastname: state.fieldValues["lastName"],
        title: state.fieldValues["title"],
        companyname: state.fieldValues["companyName"],
        street: state.fieldValues["street"],
        city: state.fieldValues["city"],
        mobile: state.fieldValues["mobileNumber"],
        areaofinterest: state.fieldValues["areaOfInterest"],
        industry: state.fieldValues["industry"],
        note: state.fieldValues["notes"],
        email: state.fieldValues["emailAddress"],
        phone: state.fieldValues["phoneNumber"],
        state: state.fieldValues["state"],
        zip: state.fieldValues["zipcodeName"],
        isemailnewsletteroptin: state.fieldValues["isEmailNewsletterOptIn"],
        formtype: state.fieldValues["formType"],
        isoutsideususer: state.fieldValues["isOutsideUSUser"],
    };
};

const CustomSendDataToApi: CustomHandlerType = async props => {
    try {
        const result = await submitContactUsForm(props.apiParameter);
        props.apiResult = {
            success: true,
        };
    } catch (err) {
        props.apiResult = {
            success: false,
        };
    }
};

export const ExecuteOnSuccessCallback: CustomHandlerType = props => {
    if (props.apiResult.success) {
        props.parameter.onSuccess?.();
    }
};

export const ExecuteOnErrorCallback: CustomHandlerType = props => {
    if (!props.apiResult.success) {
        props.parameter.onError?.();
    }
};

export const chain = [
    CustomPopulateApiParameter,
    CustomSendDataToApi,
    ExecuteOnSuccessCallback,
    ExecuteOnErrorCallback,
];

const submitContactForm = createHandlerChainRunner(chain, "SubmitContactForm");
export default submitContactForm;
